import React from 'react'
import './teacher-cancellations.css'
import axios from 'axios'
import { baseUrl } from '../assets/Animations';
import SearchHeader from '../SearchHeader/SearchHeader';
import { FilterTypeId } from '../SearchHeader/filters-type';
import { getRequestHeaders } from '../api';
import TeacherCancellationRow from './TeacherCancellationRow/TeacherCancellationRow';

const TeacherCancellations = () => {
    const [cancellations, setCancellations] = React.useState([]);
    const [touchedCancellations, setTouchedCancellations] = React.useState([]);
    const [unTouchedCancellations, setUnTouchedCancellations] = React.useState([]);
    const [teachers, setTeachers] = React.useState([]);
    const [schools, setSchools] = React.useState([]);
    const [nameQuery, setNameQuery] = React.useState('');
    const [displayExcuse, setDisplayExcuse] = React.useState(false);
    const [rowMenu, setRowMenu] = React.useState(false);
    const [filterState, setFilterState] = React.useState({});
    const [semesterTally, setSemesterTally] = React.useState({});
    const [activeMenuId, setActiveMenuId] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [loadingAfterMenuClick, setLoadingAfterMenuClick] = React.useState(false);

    const menuRef = React.useRef(null); // To reference the popup menu element

    const normalizeText = React.useCallback((value) => {
        return value == null ? '' : String(value).toLowerCase();
    }, []);

    const createSchoolFilterOptions = (res) => {
        let schoolOptions = [];
        res.forEach(school => {schoolOptions.push({ id: school.schoolAbbreviation.toLocaleLowerCase(), label: school.name.split(' ')[0] });})
        return schoolOptions
      }
    
      const createTeacherFilterOptions = (res) => {
        let teacherOptions = [];
    
        if(filterState.school) { 
          res = res.filter(teacher => {
            return teacher?.School && filterState.school.includes(String(teacher.School).toLowerCase())
          })
        }
        res.forEach(teacher => {
          if(teacher && !teacher.IsAdmin && teacher.TeacherID && teacher.Name) {
            teacherOptions.push({ id: teacher.TeacherID, label: teacher.Name });
          }
        })
    
        //alphabetize teacher
        teacherOptions.sort((a, b) => {
          if(a.label < b.label) { return -1; }
          if(a.label > b.label) { return 1; }
          return 0;
        })
    
        return teacherOptions
      }

    const filters = React.useMemo(
        () => [
          {
            id: "teachers",
            label: "Teachers",
            type: FilterTypeId.Dropdown,
            options: createTeacherFilterOptions(teachers),
          },
{
            id: "school",
            label: "School",
            type: FilterTypeId.Dropdown,
            options: createSchoolFilterOptions(schools),
          },
        ],
        [teachers, schools, filterState.school]
      );

    const sortByDate = (data) => { return data.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));};

    React.useEffect(() => {
        axios.get(`${baseUrl}/cancellation`)
        .then((response) => {
            setCancellations(sortByDate(response.data));
            setLoading(false);
        })
        .catch((error) => {
            console.error("Error fetching cancellations:", error);
        });


        axios.get(`${baseUrl}/initialadminrequest`, getRequestHeaders())
        .then((response) => {
            setTeachers(response.data);
        })
        .catch((error) => {
            console.error("Error fetching teachers:", error);
        });

        axios.get(`${baseUrl}/schools`)
        .then((response) => {
            setSchools(response.data);
        })
        .catch((error) => {
            console.error("Error fetching schools:", error);
        });

    }, []);

    React.useEffect(() => {
        const handleClickOutside = (event) => {
          if (menuRef.current && event.target.className !== 'teacher-cancellation-row__menu-item') {
            setActiveMenuId(null); // Close the menu
          }
        };
    
        // Add event listener when the menu is open
        if (activeMenuId) {
          document.addEventListener('mousedown', handleClickOutside);
        } else {
          document.removeEventListener('mousedown', handleClickOutside);
        }
    
        // Cleanup event listener on component unmount or when menu is closed
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [activeMenuId]);

    const wholeFilter = React.useCallback(() => {
      let masterTouchedList = cancellations.filter(cancellation => {
          const selectedSchools = filterState.school;
          const selectedTeachers = filterState.teachers;
          const nameFilter = normalizeText(nameQuery);
  
          // Hidden cancellations should not be displayed
          if (cancellation.hiddenByAdmin) {
              return false;
          }

          if (cancellation.untouchedByAdmin) {
              return false;
          }

          if (!cancellation.teacherCancelled) {
              return false;
          }
  
          const nameMatch = normalizeText(cancellation.familyName).includes(nameFilter) ||
              normalizeText(cancellation.studentName).includes(nameFilter) ||
              normalizeText(cancellation.familyEmail).includes(nameFilter) ||
              normalizeText(cancellation.parentName).includes(nameFilter) ||
              normalizeText(cancellation.teacherName).includes(nameFilter);
  
          const schoolMatch = !selectedSchools || selectedSchools.length === 0 ||
              (cancellation.school && selectedSchools.includes(cancellation.school.toLowerCase()));
  
          const teacherMatch = !selectedTeachers || selectedTeachers.length === 0 ||
              (cancellation.teacherId && selectedTeachers.includes(cancellation.teacherId));
  
          // Filter out cancellations for teachers who left school
          const teacher = teachers.find(teacher => teacher.TeacherID === cancellation.teacherId);
          if (teacher && teacher.Status === 'Left School') {
              return false;
          }
  
          return nameMatch && schoolMatch && teacherMatch;
      });
  
      setTouchedCancellations([...masterTouchedList]);


      let masterUnTouchedList = cancellations.filter(cancellation => {
          const selectedSchools = filterState.school;
          const selectedTeachers = filterState.teachers;
        const nameFilter = normalizeText(nameQuery);

        // Hidden cancellations should not be displayed
        if (cancellation.hiddenByAdmin) {
            return false;
        }

        if (!cancellation.untouchedByAdmin) {
            return false;
        }

        if (!cancellation.teacherCancelled) {
          return false;
      }

        const nameMatch = normalizeText(cancellation.familyName).includes(nameFilter) ||
            normalizeText(cancellation.studentName).includes(nameFilter) ||
            normalizeText(cancellation.familyEmail).includes(nameFilter) ||
            normalizeText(cancellation.parentName).includes(nameFilter) ||
            normalizeText(cancellation.teacherName).includes(nameFilter);

        const schoolMatch = !selectedSchools || selectedSchools.length === 0 ||
            (cancellation.school && selectedSchools.includes(cancellation.school.toLowerCase()));

        const teacherMatch = !selectedTeachers || selectedTeachers.length === 0 ||
            (cancellation.teacherId && selectedTeachers.includes(cancellation.teacherId));

        // Filter out cancellations for teachers who left school
        const teacher = teachers.find(teacher => teacher.TeacherID === cancellation.teacherId);
        if (teacher && teacher.Status === 'Left School') {
            return false;
        }

        return nameMatch && schoolMatch && teacherMatch;
    });

    setUnTouchedCancellations([...masterUnTouchedList]);




  }, [cancellations, filterState, nameQuery, teachers]);

    React.useEffect(() => {
        //segregate touched and untouched cancellations
        let untouched = cancellations.filter(cancellation => {
            return cancellation.untouchedByAdmin;
        })
        setUnTouchedCancellations(untouched);

        let touched = cancellations.filter(cancellation => {
            return !cancellation.untouchedByAdmin;
        })
        setTouchedCancellations(touched);

      if(cancellations.length > 0) {
          wholeFilter();
      }
    }, [filterState, nameQuery, cancellations, wholeFilter]);

      React.useEffect(() => {
        if (touchedCancellations.length > 0) {
            const semesterTally = tallyCancellationsBySemesterAndYear(touchedCancellations);
            setSemesterTally(semesterTally);
        }
    }, [touchedCancellations]);

      const tallyCancellationsBySemesterAndYear = (cancellations) => {
        const tally = {};
    
        // Iterate over each cancellation
        cancellations.forEach(cancellation => {
          if(cancellation.hiddenByAdmin) {
            return;
          } 
            const date = new Date(cancellation.dateTime);
            const month = date.getMonth() + 1; // getMonth() returns 0 for January, so +1 to match calendar months
            const year = date.getFullYear(); // Get the year
    
            let semester;
    
            // Determine which semester the month belongs to
            if (month >= 9 && month <= 12) {
                semester = 'FALL';
            } else if (month >= 1 && month <= 5) {
                semester = 'SPRING';
            } else if (month >= 6 && month <= 8) {
                semester = 'SUMMER';
            }
    
            // Create a unique key for the semester and year, e.g., 'Fall 2023'
            const key = `${semester} ${year}`;
    
            // Initialize the tally for this key if it doesn't exist, then increment it
            if (!tally[key]) {
                tally[key] = 0;
            }
            tally[key]++;
        });
    
        return tally;
    };

    const getSemesterLabel = (date) => {
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // JS months are 0-indexed
  
      if (month >= 9) {
          return `FALL ${year}`;
      } else if (month >= 6) {
          return `SUMMER ${year}`;
      } else {
          return `SPRING ${year}`;
      }
  };

  const adminTouchCancellation = (cancellationId, bool, endpoint) => {
    setLoadingAfterMenuClick(true);
    axios.put(`${baseUrl}/cancellation/${cancellationId}/${endpoint}`, { bool: bool })
        .then((response) => {
            // Find and update the specific cancellation in the cancellations list
            let index = cancellations.findIndex(c => c._id === cancellationId);
            const updatedCancellation = response.data;
            let updatedCancellations = [...cancellations];
            updatedCancellations[index] = updatedCancellation;

            // Update the cancellations state
            setCancellations(updatedCancellations);
            setActiveMenuId(null);
            setLoadingAfterMenuClick(false);
        })
        .catch((error) => {
            console.error("Error updating cancellation:", error);
            setActiveMenuId(null);
            setLoadingAfterMenuClick(false);
        });
};
  
  const shouldInjectSemesterLabel = (prevDate, currentDate) => {
      if (!prevDate) return true; // Always inject label for the first cancellation
      const prevLabel = getSemesterLabel(prevDate);
      const currentLabel = getSemesterLabel(currentDate);
      return prevLabel !== currentLabel;
  };

  const handleMenuToggle = (id) => {
    setActiveMenuId((prevId) => (prevId === id ? null : id));
};

    return (
        <div>
            <div>
                <SearchHeader title="Teacher Cancellations" onChangeQuery={(string) => setNameQuery(string)} onChangeFilters={(filterState) => setFilterState(filterState)} filters={filters} clearAll={true} />
            </div>
        {
            displayExcuse && 
                <div className='teacher-cancellation__excuse-popup'>
                    <div className='teacher-cancellation__excuse-popup__student-name'>{displayExcuse.studentName} {displayExcuse.familyName}</div>
                    <div className='teacher-cancellation__excuse-popup__excuse-text'>{displayExcuse.reason.length === 0 ? "NO REASON GIVEN" : displayExcuse.reason}</div>
                </div>
        }
        <div>
        {unTouchedCancellations.length > 0 && 
        <div className='teacher-cancellation-table__wrapper__unreviewed'>
            <div className="needs-review-semester-label__wrapper" style={{ textAlign: "center", margin: "5px 0px", fontWeight: "bold" }}>
                <div className="needs-review-semester-label">
                    <div>TO REVIEW</div>
                    <div className='needs-review-semester-label__tally'>{unTouchedCancellations.length}</div></div>
                </div>
            <div className='teacher-cancellation-unreviewed-scroll__wrapper'>
                {unTouchedCancellations.map((cancellation, index) => {
                    return (
                        <TeacherCancellationRow 
                        key={cancellation._id}
                        cancellation={cancellation} 
                        index={index} 
                        cancellations={cancellations}
                        setDisplayExcuse={setDisplayExcuse}
                        adminTouchCancellation={adminTouchCancellation}
                        rowMenu={rowMenu}
                        isOpen={activeMenuId === cancellation._id}
                        onMenuToggle={handleMenuToggle}
                        setRowMenu={setRowMenu}
                        setActiveMenuId={setActiveMenuId}
                        loadingAfterMenuClick={loadingAfterMenuClick}
                      /> 
                    )
                })}
            </div>
        </div>
                    }
        </div>
        <div className='teacher-cancellation-table__wrapper'>
        {loading && <div className='teacher-cancellation-table__loading'>Loading Cancellations...</div>}
        {touchedCancellations.map((cancellation, index) => {
          const cancellationDate = new Date(cancellation.dateTime);
          const prevCancellationDate = index > 0 ? new Date(touchedCancellations[index - 1].dateTime) : null;
          const semesterLabel = getSemesterLabel(cancellationDate);
          const shouldShowSemesterLabel = shouldInjectSemesterLabel(prevCancellationDate, cancellationDate);

          return (
                <div key={cancellation._id}>
                  {/* Inject semester label if needed */}
                  {shouldShowSemesterLabel && (
                      <div className="semester-label__wrapper" style={{ textAlign: "center", margin: "10px 0", fontWeight: "bold" }}>
                        <div className='semester-label__line'></div>
                          <div className="semester-label">
                            <div>{semesterLabel}</div>
                            <div className='semester-label__tally'>{semesterTally[semesterLabel]}</div></div>
                          <div className='semester-label__line'></div>
                      </div>
                  )}

                  <TeacherCancellationRow 
                    cancellation={cancellation} 
                    index={index} 
                    cancellations={cancellations}
                    setDisplayExcuse={setDisplayExcuse}
                    adminTouchCancellation={adminTouchCancellation}
                    rowMenu={rowMenu}
                    setRowMenu={setRowMenu}
                    isOpen={activeMenuId === cancellation._id}
                    onMenuToggle={handleMenuToggle}
                    menuRef={menuRef}
                    setActiveMenuId={setActiveMenuId}
                    loadingAfterMenuClick={loadingAfterMenuClick}
                  /> 
              </div>
          );
})}
        </div>
        </div>
    )
}
export default TeacherCancellations;
